/**
 * The one thing a phone is told (`i-0007`).
 *
 * PRD 04 §Reach is *tablet + desktop*, and the sheet means it: its own steps stop at 768px
 * and there is no phone layout under them. Until now that was silent — a narrow screen got
 * the shell anyway, folded into something unusable, and the person holding it had to work
 * out for themselves that it was never meant for them. This says it instead.
 *
 * **It is CSS that decides, not this component.** The message is always in the document and
 * the media query chooses which of the two is drawn, so the answer is right on the first
 * paint, right after a rotate, and right after a window drag, with no listener, no
 * re-render and no flash of a shell that is about to be taken away.
 *
 * Deliberately not a dead end dressed up: it says what the Studio is, so "get a bigger
 * screen" reads as a description of the tool rather than a refusal.
 */

import { Wordmark } from '@atlas-nook/design-system';
import type { JSX } from 'react';

import { useT } from './i18n/I18nProvider.js';

export function TooNarrow(): JSX.Element {
  const t = useT();

  return (
    <div className="toonarrow" role="status">
      <Wordmark />
      <h1 className="story">{t('narrow.title')}</h1>
      <p className="note">{t('narrow.body')}</p>
    </div>
  );
}
